import { axiosBase, errorHandler } from "./axios";

const getDashboard = (input: any) => {
  return axiosBase.post("/api/v1/dashboard/list", input)
      .then((response) => response.data)
      .catch((error) => errorHandler(error));
  };

  export const dashboardService = {
    getDashboard
}